export const OPEN_SMART_SELECTOR_EVENT = "yongyuan:open-smart-selector";

let pendingOpen = false;

export function openSmartSelector() {
  pendingOpen = true;
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(OPEN_SMART_SELECTOR_EVENT));
  }
}

/** SmartSelector 挂载后消费尚未处理的打开请求 */
export function consumePendingSmartSelectorOpen() {
  if (!pendingOpen) return false;
  pendingOpen = false;
  return true;
}
